import script from "./LeftDrawerNavigation.vue?vue&type=script&lang=ts&setup=true"
export * from "./LeftDrawerNavigation.vue?vue&type=script&lang=ts&setup=true"

import "./LeftDrawerNavigation.vue?vue&type=style&index=0&id=b712d37e&lang=scss&scoped=true"

import exportComponent from "/var/www/vhosts/klever-front3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b712d37e"]])

export default __exports__
import QDrawer from 'quasar/src/components/drawer/QDrawer.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDrawer,QBtn});
